// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-socialMediaBar {
  display: flex;
  flex-direction: row;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-socialMediaBar {
  justify-content: space-evenly;
}
.rDNA-socialMediaBar .rDNA-sidebarContent {
  height: 100%;
  background: #F4F7FE;
}
.rDNA-socialMediaBar .rDNA-socialIcon {
  font-size: 36px;
}
.rDNA-socialMediaBar .rDNA-socialIcon:hover {
  cursor: pointer;
  color: #A3AED0;
}
.rDNA-socialMediaBar .disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

@media screen and (max-width: 767.7px) {
  .rDNA-socialMediaBar .rDNA-socialIcon {
    font-size: 24px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-socialMediaBar .rDNA-socialIcon {
    font-size: 16px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-socialMediaBar .rDNA-socialIcon {
    font-size: 20px;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-socialMediaBar .rDNA-socialIcon {
    font-size: 28px;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-socialMediaBar .rDNA-socialIcon {
    font-size: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/shared/toolbox/social-media-bar/social-media-bar.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAMA;EAC0B,aAAA;EACA,mBAAA;ACL1B;;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADIF;ACDA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADGF;ACAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADEF;ACCA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADCF;ACEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADAF;ACGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADDF;ACIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADFF;ACKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADHF;ACMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADJF;ACOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADLF;ACQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADNF;ACSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADPF;ACUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADRF;ACWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADTF;ACYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADVF;ACaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADXF;AEzGA;;;;;uBAAA;AFHA;EAE8B,6BAAA;AAmH9B;AAlHE;EAC8B,YAAA;EACA,mBEmBf;AFiGjB;AAlHE;EAC8B,eAAA;AAoHhC;AAnHgC;EACE,eAAA;EACA,cEElB;AFmHhB;AAjHE;EAC8B,mBAAA;EACA,YAAA;EACA,oBAAA;AAmHhC;;AA/GA;EAEI;IAA8B,eAAA;EAkHhC;AACF;AA/GA;EAEI;IAA8B,eAAA;EAiHhC;AACF;AA/GA;EAEI;IAA8B,eAAA;EAiHhC;AACF;AA9GA;EAEI;IAA8B,eAAA;EAgHhC;AACF;AA7GA;EAEI;IAA8B,eAAA;EA+GhC;AACF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import 'placeholders/flexboxes';\n@import \"variables\";\n@import \"variables/breakpoints\";\n\n.rDNA-socialMediaBar        {\n                              @extend %flex-row;\n                              justify-content: space-evenly;\n  .rDNA-sidebarContent        {\n                                height: 100%;\n                                background: $app-background;\n                              }\n  .rDNA-socialIcon            {\n                                font-size: 36px;\n                                &:hover {\n                                  cursor: pointer;\n                                  color: $inactive-text;\n                                }\n                              }\n                                // Disabled state styles\n  .disabled                   {\n                                cursor: not-allowed;  // Change cursor to indicate non-clickable\n                                opacity: 0.5;         // Grey out the icon\n                                pointer-events: none; // Disable pointer events to prevent clicking\n                              }\n}\n\n@media screen and (max-width: $breakpoint-sm-max ) {\n  .rDNA-socialMediaBar        {\n    .rDNA-socialIcon            { font-size: 24px; }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  .rDNA-socialMediaBar        {\n    .rDNA-socialIcon            { font-size: 16px; }\n  }\n}\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  .rDNA-socialMediaBar        {\n    .rDNA-socialIcon            { font-size: 20px; }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  .rDNA-socialMediaBar        {\n    .rDNA-socialIcon            { font-size: 28px; }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-socialMediaBar        {\n    .rDNA-socialIcon            { font-size: 36px; }\n  }\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
